<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import A11yDialog from 'a11y-dialog'

const props = defineProps({
    id: { type: String, required: true },
    title: { type: String, default: '' },
})

const emit = defineEmits(['show', 'hide'])

const modalRef = ref(null)
let dialogInstance = null

const show = () => dialogInstance?.show()
const hide = () => dialogInstance?.hide()

onMounted(() => {
    if (modalRef.value) {
        dialogInstance = new A11yDialog(modalRef.value)

        // Bind events to maintain body class logic from modals.js
        dialogInstance.on('show', () => {
            document.body.classList.add('modal-open')
            emit('show')
        })

        dialogInstance.on('hide', () => {
            document.body.classList.remove('modal-open')
            emit('hide')
        })
    }
})

onUnmounted(() => {
    dialogInstance?.destroy()
    // Clean up class if component is destroyed while open
    document.body.classList.remove('modal-open')
})

// Expose methods to parent components
defineExpose({ show, hide })
</script>

<template>
    <Teleport to="body">
        <div class="c-modal" :id="id" aria-hidden="true" ref="modalRef">
            <div class="c-modal__overlay" data-a11y-dialog-hide></div>

            <div class="c-modal__body" role="document">
                <button
                    type="button"
                    class="c-modal__close"
                    data-a11y-dialog-hide
                    aria-label="Close dialog"
                >
                    &times;
                </button>

                <h2 v-if="title" class="c-heading c-modal__title">
                    {{ title }}
                </h2>
                <div class="c-modal__content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </Teleport>
</template>
